import React, { createContext, useState, useContext } from 'react';

// Create context for managing the media display state
const MediaDisplayContext = createContext();

/**
 * Provider component for managing media display state
 * This context allows sharing state between product videos/images
 * to synchronize showing videos or images across components
 */
export const MediaDisplayProvider = ({ children }) => {
  // State to track whether videos or images should be shown
  const [showVideos, setShowVideos] = useState(true);

  // Function to toggle between videos and images
  const toggleMediaDisplay = () => {
    setShowVideos(prev => !prev);
  };

  return (
    <MediaDisplayContext.Provider value={{ showVideos, toggleMediaDisplay }}>
      {children}
    </MediaDisplayContext.Provider>
  );
};

// Custom hook for using the media display context
export const useMediaDisplay = () => {
  const context = useContext(MediaDisplayContext);
  if (!context) {
    throw new Error('useMediaDisplay must be used within a MediaDisplayProvider');
  }
  return context;
};
